import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../../common/constants";
import { listDevicesUrl } from "../../../../config";
import { RootState } from "../../../../store";
import api from "../../../../api";
import {
  ISuperAdminDeviceState,
  IFetchSuperAdminDevicesPayload,
} from "../../../../common/types/superAdminDeviceTypes";

const GET_SUPER_ADMIN_DEVICES = "getSuperAdminDevices";

const initialState: ISuperAdminDeviceState = {
  devices: null,
  status: Status.IDLE,
  error: null,
};

export const fetchSuperAdminDeviceData = createAsyncThunk(
  GET_SUPER_ADMIN_DEVICES,
  async ({ page, limit, filter = "" }: IFetchSuperAdminDevicesPayload) => {
    const params = new URLSearchParams();
    params.append("page", String(page));
    params.append("limit", String(limit));

    if (filter) {
      params.append("filter", filter);
    }

    const url = `${listDevicesUrl}?${params.toString()}`;
    const response = await api.get(url);
    return response.data;
  }
);

const superAdminDeviceSlice = createSlice({
  name: GET_SUPER_ADMIN_DEVICES,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuperAdminDeviceData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchSuperAdminDeviceData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.devices = action.payload;
      })
      .addCase(fetchSuperAdminDeviceData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message || null;
      });
  },
});

export const selector = (state: RootState) => state.superAdminDevicesApi;

export const reducer = superAdminDeviceSlice.reducer;